import axios from "axios";
import { decryptByText, requestPayloadBodyFormate, responseDataFormate } from "../../../helpers/bycrypt";
import { catchHandler, dispatchError, dispatchLoading, dispatchToast, elseHandler } from "../../../helpers/dispatch";
import { API_URL, capitalizeFirstLetter } from "../../../helpers/utils";
import { AppDispatch } from "../../../store";
import { CreateConsumablePayload, GetConsumableParams } from "../../Types/state/masterdata";
import { GetServicesAPI } from "./services";

const APK_API_URL = `${API_URL}/admin`;

export const CreateConsumableAPI =
  (data: CreateConsumablePayload, onClose: any, ) => (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "createConsumables", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`${APK_API_URL}/consumable`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "createConsumables", undefined);
        } else elseHandler(dispatch, "createConsumables", result);
        dispatchLoading(dispatch, "createConsumables", false);
      })
      // .catch(catchHandler(dispatch,"createConsumables"));
      .catch((e) => {
        catchHandler(dispatch, "createConsumables")(e);
      });
  };

export const GetConsumableAPI =
  (
    {
      page,
      limit,
      search,
      start_date,
      end_date,
      is_active,
      export_data,
      order,
      unit,
      vendor,
      tax,
    }: GetConsumableParams,
    setHasMore?: any
  ) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatchLoading(dispatch, "getConsumables", true);
    // setIsLoading(true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;
    if (is_active) params["is_active"] = is_active;
    if (export_data) params["export_data"] = export_data;
    if (order) params["order"] = [order];
    if (unit) params["unit"] = unit;
    if (vendor) params["contact_id"] = vendor;
    if (tax) params["tax"] = tax;

    axios
      .get(`${APK_API_URL}/consumable/list`, {
        params: { ...params },
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          const responseData = result?.data?.data?.map((elem: any) => {
            const customerfname = decryptByText(elem?.contact_id?.first_name);
            const customerlname = decryptByText(elem?.contact_id?.last_name);
            const customerEmail = decryptByText(elem?.contact_id?.email);
            return {
              ...elem,
              contact_id: {
                ...elem?.contact_id,
                first_name: capitalizeFirstLetter(customerfname),
                last_name: capitalizeFirstLetter(customerlname),
                full_name: `${capitalizeFirstLetter(customerfname)} ${capitalizeFirstLetter(customerlname)}`,
                email: customerEmail,
              },
            };
          });
          dispatch({
            type: "GET_CONSUMABLES",
            payload: { data: responseData, count: result?.data?.count, page: page },
          });
          if (setHasMore) {
            setHasMore(result?.data?.data?.length == limit);
          }
          dispatchError(dispatch, "getConsumables", undefined);
        } else elseHandler(dispatch, "getConsumables", result);
        dispatchLoading(dispatch, "getConsumables", false);
      })
      .catch((e) => {
        // setIsLoading(false);
        catchHandler(dispatch, "getConsumables")(e);
      });
  };

export const UpdateConsumableAPI =
  (data: any, onClose: any, isService: any, servicesGetPayload: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "editConsumables", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`${APK_API_URL}/consumable`, formatedData, { withCredentials: true })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          if (isService) {
            dispatch(GetServicesAPI(servicesGetPayload));
          } else {
            const customerfname = decryptByText(result?.data?.contact_id?.first_name);
            const customerlname = decryptByText(result?.data?.contact_id?.last_name);
            dispatch({
              type: "UPDATE_CONSUMABLES",
              payload: {
                ...result?.data,
                contact_id: {
                  ...result?.data?.contact_id,
                  first_name: customerfname,
                  last_name: customerlname,
                  full_name: `${customerfname ?? ""} ${customerlname ?? ""}`,
                },
              },
            });
          }
          // dispatch(GetConsumableAPI(consumablesGetPayload));
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "editConsumables", undefined);
          onClose();
        } else elseHandler(dispatch, "editConsumables", result);
        dispatchLoading(dispatch, "editConsumables", false);
      })
      .catch(catchHandler(dispatch, "editConsumables"));
  };

export const DeleteConsumableAPI =
  (data: { id: string }, onClose: any, consumablesGetPayload: GetConsumableParams) => (dispatch: AppDispatch) => {
    const formatedData: any = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteConsumables", true);
    axios
      .delete(`${APK_API_URL}/consumable`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "DELETE_CONSUMABLES",
            payload: data?.id,
          });
          // dispatch(GetConsumableAPI(consumablesGetPayload));
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteConsumables", undefined);
        } else elseHandler(dispatch, "deleteConsumables", result);
        dispatchLoading(dispatch, "deleteConsumables", false);
      })
      .catch(catchHandler(dispatch, "deleteConsumables"));
  };

export const PermanaentDeleteConsumableAPI =
  (data: { id: string }, onClose: any, consumablesGetPayload: GetConsumableParams) => (dispatch: AppDispatch) => {
    const formatedData: any = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteConsumables", true);
    axios
      .delete(`${APK_API_URL}/consumable/permanent`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "DELETE_CONSUMABLES",
            payload: data?.id,
          });
          // dispatch(GetConsumableAPI(consumablesGetPayload));
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteConsumables", undefined);
        } else elseHandler(dispatch, "deleteConsumables", result);
        dispatchLoading(dispatch, "deleteConsumables", false);
      })
      .catch(catchHandler(dispatch, "deleteConsumables"));
  };

export const RestoreConsumableAPI =
  (data: any, onClose: any, consumablesGetPayload: GetConsumableParams) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "restoreConsumables", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`${APK_API_URL}/consumable/restore`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "DELETE_CONSUMABLES",
            payload: data?.id,
          });
          // dispatch(GetConsumableAPI(consumablesGetPayload));
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "restoreConsumables", undefined);
        } else elseHandler(dispatch, "restoreConsumables", result);
        dispatchLoading(dispatch, "restoreConsumables", false);
      })
      .catch(catchHandler(dispatch, "restoreConsumables"));
  };

export const UploadConsumablesCsvAPI =
  (
    data: any,
    onClose: any,
    consumablesGetPayload: GetConsumableParams,
    setIsInvalidaDataModal?: any,
    setIsInvalidCsvData?: any,
    setIsAlreadyCsvData?: any,
    setIsInsertCsvData?: any
  ) =>
  (dispatch: AppDispatch) => {
    dispatchLoading(dispatch, "uploadConsumablesCsv", true);
    // const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`${APK_API_URL}/consumable/bulk`, data, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          setIsInvalidaDataModal(true);
          if (result?.data?.invalid_data?.length > 0) {
            setIsInvalidCsvData(result?.data?.invalid_data);
          }
          if (result?.data?.already_exist?.length > 0) {
            setIsAlreadyCsvData(result?.data?.already_exist);
          }
          if (result?.data?.insert_data?.length > 0) {
            setIsInsertCsvData(result?.data?.insert_data);
          }
          dispatch(GetConsumableAPI(consumablesGetPayload));
          // dispatchToast(dispatch, "success", result?.message);
          onClose();
          dispatchError(dispatch, "uploadConsumablesCsv", undefined);
        } else elseHandler(dispatch, "uploadConsumablesCsv", result);
        dispatchLoading(dispatch, "uploadConsumablesCsv", false);
      })
      // .catch(catchHandler(dispatch,"uploadConsumablesCsv"));
      .catch((e) => {
        catchHandler(dispatch, "uploadConsumablesCsv")(e);
      });
  };

export const DownloadConsumablesCsvFileAPI =
  ({ page, limit, is_active, export_data, filename }: GetConsumableParams) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatchLoading(dispatch, "downloadConsumablesFile", true);
    // setIsLoading(true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (is_active) params["is_active"] = is_active;
    if (export_data) params["export_data"] = export_data;
    axios
      .get(`${APK_API_URL}/consumable/list`, {
        params: { ...params },
        withCredentials: true,
      })
      .then((response) => {
        const result = response?.data;
        if (result) {
          dispatchLoading(dispatch, "downloadConsumablesFile", false);
          const blob = new Blob([result], { type: "text/csv" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${filename}.csv`;
          link.click();
          dispatchError(dispatch, "downloadConsumablesFile", undefined);
        } else elseHandler(dispatch, "downloadConsumablesFile", result);
        dispatchLoading(dispatch, "downloadConsumablesFile", false);
      })
      .catch((e) => {
        // setIsLoading(false);
        catchHandler(dispatch, "downloadConsumablesFile")(e);
      });
  };
